import { cx } from '@linaria/core';
import { CircleLoader } from 'components/CircleLoader';
import { SpinnerSize } from 'components/CircleLoader/CircleLoader';
import { textRegular } from 'styles/typography';
import { cssHelpers } from 'styles/utils/core';
import { loaderWrapper } from './BoxLoader.styles';
export interface BoxLoaderProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  type: 'progress' | 'spinner';
  title?: React.ReactNode;
  content?: React.ReactNode;
  progress?: number;
  icon?: React.ReactNode;
  spinnerSize?: SpinnerSize;
}
export function BoxLoader({
  type,
  title,
  content,
  progress,
  icon,
  className,
  spinnerSize,
  ...rest
}: BoxLoaderProps): JSX.Element {
  return <div className={cx(loaderWrapper, className)} {...rest}>
      {icon}
      {(title || content) && <div className={cssHelpers.margin.xr[1]}>
          {title && <div className={cx('title')}>{title}</div>}
          {content && <div className={cx('content', textRegular)}>{content}</div>}
        </div>}
      {!progress && type === 'spinner' && <CircleLoader size={spinnerSize} />}
    </div>;
}